import { EnvironmentProviders } from '@angular/core';

import { providePrimeNG } from 'primeng/config';
import { primengTranslation } from '../i18n';
import { GextorPreset } from './theme/gextor.preset';

/**
 * Provedor de configuração do tema PrimeNG
 *
 * Utiliza o GextorPreset customizado que define:
 * - Cor primária: paleta azul do GextorPro (#587bfc como cor base)
 * - Cores de superfície: paleta slate do GextorPro
 *
 * @see src/app/core/config/theme/gextor.preset.ts
 */
export function providePrimeNGTheme(): EnvironmentProviders {
  return providePrimeNG({
    translation: primengTranslation,
    ripple: true,
    theme: {
      preset: GextorPreset,
      options: {
        darkModeSelector: false,
        cssLayer: false
      }
    }
  });
}
